export default __webpack_public_path__ + "static/media/69_photo.f7239da0.jpg";